import React from 'react';
import PropTypes from 'prop-types';

const Control = ({ children }) => (
  <div className="app-form-control">
    {children}
  </div>
);

Control.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Control;
